export var transitionTokens = {
  simple: {
    background: {
      property: 'background',
      easing: 'easeInOutCubic'
    },
    borderColor: {
      property: 'borderColor',
      duration: 'fast'
    }
  },
  enterLeave: {
    fade: {
      from: {
        opacity: 0
      },
      enter: {
        opacity: 1
      },
      leave: {
        opacity: 0
      }
    },
    scale: {
      from: {
        opacity: 0,
        transform: "scale(0.9)"
      },
      enter: {
        opacity: 1,
        transform: "scale(1)"
      },
      leave: {
        opacity: 0,
        transform: "scale(0.5)"
      }
    },
    slideUp: {
      from: {
        transform: 'translateY(100%)'
      },
      enter: {
        transform: 'translateY(0%)'
      },
      leave: {
        transform: 'translateY(100%)'
      }
    }
  }
};